const options: Intl.DateTimeFormatOptions = {
  weekday: undefined,
  year: 'numeric',
  month: 'short',
  day: 'numeric',
}

export const formatDate = (date?: string): string | null =>
  date ? new Date(date).toLocaleDateString(undefined, options) : null
